import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import MoleculeRating, {MoleculeRatingSizes} from '@s-ui/react-molecule-rating'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'

import {customStarIcons, DEFAULT_EMPTY_SYMBOL, DEFAULT_MAX_RATINGS, DESIGNS} from './config.js'

const RatingBasic = ({
  design = DESIGNS.DARK,
  description = null,
  label,
  onClickLabel,
  size = MoleculeRatingSizes.SMALL,
  value
}) => {
  const {i18n} = useContext(Context)

  const hasNotReviews = label === i18n.t('DEALER_RATINGS.EMPTY')

  const hasValue = Boolean(value)

  const parsedValue = hasValue ? value : DEFAULT_EMPTY_SYMBOL

  const baseClassNames = cx('mt-RatingBasic', `mt-RatingBasic--${design}`)

  const classNamesLabel = cx('mt-RatingBasic-label', {
    'mt-RatingBasic-label--is-not-link': hasNotReviews
  })

  const handleClickLabel = () => onClickLabel()

  return (
    <div className={baseClassNames}>
      <div className="mt-RatingBasic-info">
        <p className="mt-RatingBasic-infoValue">
          <VisuallyHidden>{i18n.t('COMMON.PLURALS.RATING', 0)}</VisuallyHidden>
          {parsedValue}
          <VisuallyHidden>{i18n.t('COMMON.OF_COUNT', {smart_count: DEFAULT_MAX_RATINGS})}</VisuallyHidden>
        </p>
        <MoleculeRating size={size} value={value} {...customStarIcons} />
      </div>
      {description && <p className="mt-RatingBasic-description">{description}</p>}
      {label && (
        <p className={classNamesLabel} onClick={handleClickLabel}>
          {label}
        </p>
      )}
    </div>
  )
}

RatingBasic.displayName = 'RatingBasic'
RatingBasic.propTypes = {
  description: PropTypes.string,
  design: PropTypes.oneOf(Object.values(DESIGNS)),
  label: PropTypes.string,
  onClickLabel: PropTypes.func,
  size: PropTypes.oneOf(Object.values(MoleculeRatingSizes)),
  value: PropTypes.number
}

export {MoleculeRatingSizes as ratingBasicSizes, DESIGNS as ratingBasicDesigns}

export default RatingBasic
